<div class="content-area">
  <div class="title-block">
    <h1>Appointment Reassignment(s) from {{ navSourceTherapistName }}</h1>
     <div class="title-block__right">
      <a class="back-btn" href="javascript:void(0);" (click)="back()"><i class="back-new"></i> Back</a>
    </div>
  </div>

  <div class="reassign-tables-outer">
    <!-- ── Appointment Groups ────────────────────────────────────────────── -->
    <div class="reassign-groups-section" *ngIf="appointmentGroups.length > 0">

      <!-- ▶ WHOLE GROUP mode -->
      <table class="table-outer group-appt-table" *ngIf="isReassignWholeGroup">
        <thead *ngIf="hasAnyPendingGroup">
          <tr>
            <th class="group-th" width="25%">Patient Name</th>
            <th class="group-th" width="25%">Appointment Time</th>
            <th class="group-th" width="35%">Reassign to</th>
            <th class="group-th" width="15%">Action</th>
          </tr>
        </thead>
        <ng-container *ngFor="let group of appointmentGroups">
          <tbody class="reassign-group-card" *ngIf="!isGroupFullyAdded(group)">
            <tr *ngFor="let patient of group.patients; let i = index" class="group-data-row">
              <td class="group-td">{{ patient.patientName }}</td>
              <ng-container *ngIf="i === 0">
                <td class="group-td group-span-cell" [attr.rowspan]="group.patients.length">
                  {{ group.timeSlot }}
                </td>
                <!-- Therapists available → show dropdown + Add button -->
                <ng-container *ngIf="getTherapistOptionsForTimeSlot(group.timeSlot).length > 0; else noTherapistWhole">
                  <td class="group-td group-span-cell" [attr.rowspan]="group.patients.length">
                    <p-select
                      class="group-dropdown form__dropdown select-box"
                      [options]="getTherapistOptionsForTimeSlot(group.timeSlot)"
                      [(ngModel)]="group.selectedTargetTherapistId"
                      placeholder="Select Therapist"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      appendTo="body">
                    </p-select>
                  </td>
                  <td class="group-td group-span-cell" [attr.rowspan]="group.patients.length">
                    <button class="btn btn-add" (click)="addGroupToFinal(group)">
                      <i class="pi pi-plus"></i> Add
                    </button>
                  </td>
                </ng-container>
                <!-- No therapists available → span both columns with warning -->
                <ng-template #noTherapistWhole>
                  <td class="group-td group-span-cell" colspan="2" [attr.rowspan]="group.patients.length">
                    <span *ngIf="loadingTherapists" class="reassign-slot-loader">
                      <i class="pi pi-spin pi-spinner"></i>
                    </span>
                    <div *ngIf="!loadingTherapists" class="reassign-no-therapist-warning">
                      <div><i class="pi pi-exclamation-triangle"></i> No therapist available for this time slot.</div>
                      <div class="reassign-no-therapist-hint">Please check the therapist availability, classification mapping, and license mapping and try again.</div>
                    </div>
                  </td>
                </ng-template>
              </ng-container>
            </tr>
          </tbody>
        </ng-container>
      </table>

      <!-- ▶ INDIVIDUAL mode -->
      <table class="table-outer group-appt-table" *ngIf="!isReassignWholeGroup">
        <thead *ngIf="hasAnyPendingGroup">
          <tr>
            <th class="group-th" width="25%">Patient Name</th>
            <th class="group-th" width="25%">Appointment Time</th>
            <th class="group-th" width="35%">Reassign to</th>
            <th class="group-th" width="15%">Action</th>
          </tr>
        </thead>
        <ng-container *ngFor="let group of appointmentGroups">
          <tbody class="reassign-group-card" *ngIf="!isGroupFullyAdded(group)">
            <ng-container *ngFor="let patient of group.patients">
              <tr *ngIf="!isPatientAdded(patient.appointmentId)" class="group-data-row">
                <td class="group-td">{{ patient.patientName }}</td>
                <td class="group-td">{{ patient.appointmentTime }}</td>
                <!-- Therapists available → show dropdown + Add button -->
                <ng-container *ngIf="getTherapistOptionsForTimeSlot(patient.appointmentTime, patient.appointmentId).length > 0; else noTherapistIndividual">
                  <td class="group-td">
                    <p-select
                      class="group-dropdown form__dropdown select-box"
                      [options]="getTherapistOptionsForTimeSlot(patient.appointmentTime, patient.appointmentId)"
                      [(ngModel)]="patient.selectedTargetTherapistId"
                      placeholder="Select Therapist"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      appendTo="body">
                    </p-select>
                  </td>
                  <td class="group-td">
                    <button class="btn btn-add" (click)="addPatientToFinal(group, patient)">
                      <i class="pi pi-plus"></i> Add
                    </button>
                  </td>
                </ng-container>
                <!-- No therapists available → span both columns with warning -->
                <ng-template #noTherapistIndividual>
                  <td class="group-td" colspan="2">
                    <span *ngIf="loadingTherapists" class="reassign-slot-loader">
                      <i class="pi pi-spin pi-spinner"></i>
                    </span>
                    <div *ngIf="!loadingTherapists" class="reassign-no-therapist-warning">
                      <div><i class="pi pi-exclamation-triangle"></i> No therapist available for this time slot.</div>
                      <div class="reassign-no-therapist-hint">Please check the therapist availability, classification mapping, and license mapping and try again.</div>
                    </div>
                  </td>
                </ng-template>
              </tr>
            </ng-container>
          </tbody>
        </ng-container>
      </table>

    </div><!-- /.reassign-groups-section -->

    <!-- Empty state -->
    <div class="reassign-no-data" *ngIf="appointmentGroups.length === 0">
      <i class="pi pi-calendar-times"></i>
      <p>No appointments loaded yet.</p>
    </div>

    <!-- ── Final Reassignment Table ───────────────────────────────────────── -->
    <div class="reassign-final-section">
      <div class="reassign-final-section__header">
        <h2>
          Final Reassignment
          <span class="final-count-badge" *ngIf="finalRows.length > 0">{{ finalRows.length }}</span>
        </h2>
      </div>

    <div class="final-table-scroll">
    <table class="table-outer group-appt-table">
      <thead *ngIf="finalRows.length > 0">
        <tr>
          <th class="group-th" width="20%">Patient Name</th>
          <th class="group-th" width="20%">Appointment Time</th>
          <th class="group-th" width="20%">Reassign to</th>
          <th class="group-th" width="25%">Mark source therapist N/A</th>
          <th class="group-th final-th-action" width="15%">Action</th>
        </tr>
      </thead>

      <tbody *ngIf="finalRows.length > 0">
        <tr class="group-data-row" *ngFor="let row of finalRows; let i = index">
          <td class="group-td">{{ row.patientName }}</td>
          <td class="group-td">{{ row.appointmentTime }}</td>
          <td class="group-td">{{ row.targetTherapistName }}</td>

          <!-- N/A: merged checkbox when ALL group patients are staged -->
          <td *ngIf="isGroupCompleteInFinal(row.groupId) && isFirstInFinalGroupByGroupId(row, i)"
              class="group-td"
              [attr.rowspan]="getFinalGroupRowspanByGroupId(row)">
            <p-checkbox
              [(ngModel)]="row.markSourceTherapistNA"
              binary="true"
              (onChange)="syncMarkNAForGroup(row.groupId, $event.checked)">
            </p-checkbox>
          </td>
          <!-- Empty placeholder keeps column aligned while group is still partial -->
          <td *ngIf="!isGroupCompleteInFinal(row.groupId)"
              class="group-td"></td>

          <!-- WHOLE GROUP mode: one Remove Group button spans all rows of the group -->
          <ng-container *ngIf="isReassignWholeGroup">
            <td *ngIf="isFirstInFinalGroup(row, i)"
                class="group-td final-td-action list-border-none"
                [attr.rowspan]="getFinalGroupRowspan(row)">
              <button class="btn btn-remove" (click)="removeGroupFromFinal(row)">
                <i class="pi pi-times"></i> Remove
              </button>
            </td>
          </ng-container>

          <!-- INDIVIDUAL mode: each row has its own Remove button -->
          <ng-container *ngIf="!isReassignWholeGroup">
            <td class="group-td final-td-action">
              <button class="btn btn-remove" (click)="removeFinalRow(i)">
                <i class="pi pi-times"></i> Remove
              </button>
            </td>
          </ng-container>

        </tr>
      </tbody>

      <tbody *ngIf="finalRows.length === 0">
        <tr>
          <td colspan="5" class="final-empty-msg">
            <i class="pi pi-inbox"></i>&nbsp;
            No reassignments added yet — use the groups above to add entries.
          </td>
        </tr>
      </tbody>

    </table>
  </div>

      <!-- Save / Clear action bar -->
      <div class="reassign-save-bar" *ngIf="finalRows.length > 0">
        <button class="btn btn--secondary" (click)="clearAll()" [disabled]="saving">
          <i class="pi pi-times"></i> Clear All
        </button>
        <button class="btn btn--primary" (click)="saveAll()" [disabled]="saving">
          <i class="pi pi-spin pi-spinner" *ngIf="saving"></i>
          <i class="pi pi-save" *ngIf="!saving"></i>
          {{ saving ? 'Saving...' : 'Save All Reassignments' }}
        </button>
      </div>

    </div>

  </div>

</div>